import * as _ from 'lodash';
import { useEffect, useState, useRef } from 'react';
import { ApiRequest } from 'GlobalFunctions';

export const validateEmail = (email: string): boolean => {
    // Implement full email validation
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    return re.test(email);
};

export default function ClientForm(props: any) {

    const {
        formValues,
        setFormValues,
        checkTaxesAndShipping
    } = props;

    const [isInitialized, setIsInitialized] = useState(false);
    const [countries, setCountries] = useState<any[]>([]);
    const [states, setStates] = useState<any>({}); 


    /*=========================================================
    INITIALIZE
    =========================================================*/
    useEffect(() => {
        if(!isInitialized){
            getCountries().then(() => {
                SetClientInfo();
                initializeDisabledFields();
            });
        }
    }, [isInitialized]);
    
    // useEffect(() => {
    //     if (isInitialized) {
    //         isFormComplete();
    //     }
    // }, [isInitialized]);

    // Estados para almacenar países y estados



    /*=========================================================
    GET COUNTRIES
    =========================================================*/
    const getCountries = () => {
        return new Promise<void>((resolve, reject) => {
            ApiRequest({
                url: '/countries/getCountries',
                method: 'GET',
                setResponse: (response: any) => {
                    setCountries(response);
                    fillCountrySelect('country', response);
                    fillCountrySelect('s-country', response);
                    resolve(); // Resolve the promise after countries are set
                }
            });
        });
    };

    const fillCountrySelect = (pcAttribute: string, countries: any[]) => {
        const selectElement = document.querySelector(`[pc="${pcAttribute}"]`) as HTMLSelectElement;
        if (selectElement) {
            countries.forEach((country: any) => {
                const option = document.createElement('option');
                option.value = country.country_id;
                option.innerHTML = country.country_name;
                selectElement.appendChild(option);
            });
        }
    };

    const clearStateSelect = (selectElement: HTMLSelectElement) => {
        const stateSelect = getStateSelect(selectElement);
        if (stateSelect) {
            stateSelect.innerHTML = '<option value=" ">Select State</option>'; // Limpiar y agregar opción por defecto
        }
    };

    /*=========================================================
    GET REGIONS (STATES) FOR A COUNTRY
    =========================================================*/
    const getRegions = (country_id: any, selectElement: HTMLSelectElement, selectedRegionId?: any) => {
        return new Promise<void>((resolve, reject) => {
            ApiRequest({
                url: '/countries/getRegions',
                method: 'GET',
                query: {
                    country_id
                },
                setResponse: async (response: any) => {
                    setStates((prevStates: any) => ({
                        ...prevStates,
                        [country_id]: response.list
                    }));


                    const stateSelect = getStateSelect(selectElement);
                    if (stateSelect) {
                        // Limpiar estados anteriores y agregar opción por defecto
                        stateSelect.innerHTML = '<option value="">Select State</option>';
                        response.list.forEach((state: any) => {
                            const option = document.createElement('option');
                            option.value = state.region_id;
                            option.innerHTML = state.region_name;
                            stateSelect.appendChild(option);
                        });

                        if (selectedRegionId) {
                            stateSelect.value = selectedRegionId.toString(); // Set the value after options are added
                            const event = new Event('change', { bubbles: true });
                            stateSelect.dispatchEvent(event);
                        }
                    }
                    resolve(); // Resolve after states are set
                }
            });
        });
    };


    /*=========================================================
    SET CLIENT INFO
    =========================================================*/
    const SetClientInfo = async () => {

        const cart = JSON.parse(localStorage.getItem('cart') || '{}');
        const data = cart.client || {};

        // Validate email and phone
        const isValidEmail = validateEmail(data.email);
        const isValidPhone = validatePhone(data.phone);

        setFormValues((prevFormValues: any) => ({ 
            ...prevFormValues, 
            ...data,
            isValidEmail,
            isValidPhone
        }));


        const elements = [
            { key: 'fname', selector: 'input[pc="fname"]' },
            { key: 'lname', selector: 'input[pc="lname"]' },
            { key: 'address', selector: 'input[pc="address"]' },
            { key: 'address2', selector: 'input[pc="address2"]' },
            { key: 'postal', selector: 'input[pc="postal"]' },
            { key: 'city', selector: 'input[pc="city"]' },

            { key: 's_fname', selector: 'input[pc="s-fname"]' },
            { key: 's_lname', selector: 'input[pc="s-lname"]' },
            { key: 's_address', selector: 'input[pc="s-address"]' },
            { key: 's_address2', selector: 'input[pc="s-address2"]' },
            { key: 's_postal', selector: 'input[pc="s-postal"]' },
            { key: 's_city', selector: 'input[pc="s-city"]' },
            { key: 's_country', selector: 'select[pc="s-country"]' },

            { key: 'email', selector: 'input[pc="email"]' },
            { key: 'phone', selector: 'input[pc="phone"]' },
        ];

        // Actualiza los valores de los inputs
        elements.forEach(({ key, selector }) => {
            const element = document.querySelector(selector) as HTMLInputElement | HTMLSelectElement;
            if (element && data[key] !== undefined && data[key] !== null && data[key] !== '' && data[key] !== 0) {
                element.value = data[key];
                const event = new Event('input', { bubbles: true });
                element.dispatchEvent(event);
            }
        });

        

        /*=========================================================
        SET COUNTRY AND STATE (123)
        =========================================================*/
        if (data.country) {
            const billingCountrySelect = document.querySelector('select[pc="country"]') as HTMLSelectElement;
            if (billingCountrySelect) {
                billingCountrySelect.value = data.country;
                await getRegions(data.country, billingCountrySelect, data.state); // Pass data.state as selectedRegionId
            }
        }

        if (data.s_country) {
            const shippingCountrySelect = document.querySelector('select[pc="s-country"]') as HTMLSelectElement;
            if (shippingCountrySelect) {
                shippingCountrySelect.value = data.s_country;
                await getRegions(data.s_country, shippingCountrySelect, data.s_state); // Pass data.s_state as selectedRegionId
            }
        }


        const sameShippingBilling = document.querySelector('input[pc="same-as"]') as HTMLInputElement;
        
        if (sameShippingBilling && data.sameShippingBilling !== undefined) {
            sameShippingBilling.checked = data.sameShippingBilling;
            if (data.sameShippingBilling) {
                const event = new Event('change', { bubbles: true });
                sameShippingBilling.dispatchEvent(event);
    
                const shippingFieldsContainer = document.querySelector('[pc="shipping-information"]');
                if (shippingFieldsContainer) {
                    shippingFieldsContainer.classList.add('hidden');
                }
            }
            
        }

        /*=========================================================
        CHECK TERMS
        =========================================================*/
        const checkTerms = document.querySelector('input[pc="terms"]') as HTMLInputElement;
        if (checkTerms && data.checkTerms !== undefined) {

            if (data.checkTerms){
                checkTerms.checked = data.checkTerms;
                const event = new Event('change', { bubbles: true });
                checkTerms.dispatchEvent(event);
            }
        }

        await validateAddressFields(data);
        

        setIsInitialized(true);
        attachEventListeners();
    };




    /*=========================================================
    UPDATE INFO (sin debounce)
    =========================================================*/
    const isAddressComplete = (values: any, isShipping: boolean = false) => {
        const prefix = isShipping ? 's_' : '';
        const requiredFields = [
            `${prefix}postal`, 
            `${prefix}address`, 
            `${prefix}country`, 
            `${prefix}state`, 
            `${prefix}city`
        ];
        
        return requiredFields.every(field => 
            values[field] !== undefined && 
            values[field] !== null && 
            values[field] !== ''
        );
    };

    const updateInfo = async () => {
        const cartBase = JSON.parse(localStorage.getItem('cart') || '{}');
        const cart = { ...cartBase };
        cart.client = formValues;
        localStorage.setItem('cart', JSON.stringify(cart));
        
        checkTriggerTaxesAndShipping(cartBase);
        
    };


    const checkTriggerTaxesAndShipping = async (cartBase: any) => {
        const billingFields = ['postal', 'address', 'address2', 'country', 'state', 'city', 'city_id'];
        const shippingFields = ['s_postal', 's_address', 's_address2', 's_country', 's_state', 's_city', 's_city_id'];
        
        const sameShippingBillingChanged = formValues.sameShippingBilling !== cartBase.client?.sameShippingBilling;

        const fieldsToCheck = formValues.sameShippingBilling ? billingFields : shippingFields;
        
        const addressChanged = fieldsToCheck.some(field => 
            formValues[field] !== cartBase.client?.[field]
        );
        
        if (addressChanged || sameShippingBillingChanged) {
            console.log('Address fields changed or same-as checkbox toggled, checking completeness');
            
            // Determine which address to validate based on checkbox state
            const isComplete = formValues.sameShippingBilling 
                ? isAddressComplete(formValues)         // Check billing address when same-as is checked
                : isAddressComplete(formValues, true);  // Check shipping address when same-as is unchecked
            
            if (isComplete) {
                console.log('Address complete, triggering checkTaxesAndShipping');
                if (typeof checkTaxesAndShipping === 'function') {
                    checkTaxesAndShipping();
                }
            } else {
                console.log('Address incomplete, not triggering checkTaxesAndShipping');
            }
        }
    }

    useEffect(() => {
        if (isInitialized) {
            const debouncedUpdate = _.debounce(updateInfo, 500);
            debouncedUpdate();

            return () => {
                debouncedUpdate.cancel();
            };
        }
    }, [formValues]);

    useEffect(() => {
        // Synchronize billing city input
        const billingCityInput = document.querySelector('input[pc="city"]') as HTMLInputElement;
        if (billingCityInput) {
            billingCityInput.value = formValues.city || '';
        }

        // Synchronize shipping city input
        const shippingCityInput = document.querySelector('input[pc="s-city"]') as HTMLInputElement;
        if (shippingCityInput) {
            shippingCityInput.value = formValues.s_city || '';
        }
    }, [formValues.city, formValues.s_city]);

    /*=========================================================
    ATTACH EVENT LISTENERS
    =========================================================*/
    const handleFocusOut = (event: Event) => {
        const input = event.target as HTMLInputElement | HTMLSelectElement;
        const pcAttribute = input.getAttribute('pc');
        if (pcAttribute) {
            if (input.value.trim() === '' || input.tagName === 'SELECT') {
                // Obtiene los estilos de :focus y los aplica a la clase focused
                const computedStyles = window.getComputedStyle(input);
                const stylesToClone = ['outline', 'border', 'background-color', 'color', 'box-shadow'];

                stylesToClone.forEach(prop => {
                    input.style.setProperty(prop, computedStyles.getPropertyValue(prop));
                });

                input.classList.add('focused');
            } else {
                input.classList.remove('focused');
                // Remove the applied styles
                input.style.removeProperty('outline');
                input.style.removeProperty('border');
                input.style.removeProperty('background-color');
                input.style.removeProperty('color');
                input.style.removeProperty('box-shadow');
            }
        }
    };
    
    const attachEventListeners = () => {
        const inputs = document.querySelectorAll('input[pc]');
        inputs.forEach(input => {
            const dataPc = input.getAttribute('pc');
            if (dataPc ) {
                input.addEventListener('input', handleInputChange);
                input.addEventListener('focusout', handleFocusOut);
                input.addEventListener('focus', () => input.classList.remove('focused'));
            }
        });
    
        const selects = document.querySelectorAll('select[pc]');
        selects.forEach(select => {
            select.addEventListener('change', handleSelectChange);
            select.addEventListener('focusout', handleFocusOut);
            select.addEventListener('focus', () => select.classList.remove('focused'));
        });
    
        const checkbox = document.querySelector('input[pc="same-as"]');
        if (checkbox) {
            checkbox.addEventListener('change', handleSameAsChange);
            checkbox.addEventListener('focusout', handleFocusOut);
            checkbox.addEventListener('focus', () => checkbox.classList.remove('focused'));
        }
    
        const terms = document.querySelector('input[pc="terms"]');
        if (terms) {
            terms.addEventListener('change', handleTermsChange);
            terms.addEventListener('focusout', handleFocusOut);
            terms.addEventListener('focus', () => terms.classList.remove('focused'));
        }
    };
    

    /*=========================================================
    HANDLE INPUT CHANGE
    =========================================================*/
    const validatePhone = (phone: string): boolean => {
        const re = /^\+?[1-9]\d{1,14}$/;
        return re.test(phone);
    };

    const handleInputChange = (event: Event) => {
        const input = event.target as HTMLInputElement;
        const pc = input.getAttribute('pc')?.replace('-', '_');
        if (pc) {
            const value = input.value;

            let updates: any = { [pc]: value };

            // If email field changes, validate email
            if (pc === 'email') {
                updates.isValidEmail = validateEmail(value);
            }

            // If phone field changes, validate phone
            if (pc === 'phone') {
                updates.isValidPhone = validatePhone(value);
            }

            // Check the actual checkbox state directly from the DOM
            const sameAsCheckbox = document.querySelector('input[pc="same-as"]') as HTMLInputElement;
            const isSameShippingBilling = sameAsCheckbox?.checked || false;
            
            if (isSameShippingBilling && !pc.startsWith('s_')) {
                // Update state
                const shippingFieldKey = `s_${pc}`;
                updates[shippingFieldKey] = value;
                
                // Special handling for city_id
                if (pc === 'city_id') {
                    updates.s_city_id = value;
                    console.log('Syncing city_id to s_city_id:', value); // Debug logging
                }
                
                // Update DOM element
                const shippingFieldPc = `s-${pc.replace('_', '-')}`;
                const shippingInput = document.querySelector(`[pc="${shippingFieldPc}"]`) as HTMLInputElement | HTMLSelectElement;
                if (shippingInput) {
                    shippingInput.value = value;
                    // Dispatch appropriate event for the element type
                    const eventType = shippingInput.tagName === 'SELECT' ? 'change' : 'input';
                    const syncEvent = new Event(eventType, { bubbles: true });
                    shippingInput.dispatchEvent(syncEvent);
                }
            }

            setFormValues((prevFormValues: any) => ({ 
                ...prevFormValues, 
                ...updates,
                // Also make sure to update sameShippingBilling based on the checkbox
                sameShippingBilling: isSameShippingBilling 
            }));
        }
    };

    /*=========================================================
    HANDLE SELECT CHANGE
    =========================================================*/
    const handleSelectChange = async (event: Event) => {
        const selectElement = event.target as HTMLSelectElement;
        const pc = selectElement.getAttribute('pc')?.replace('-', '_');
        if (pc) {
            const value = selectElement.value;
            
            // Get the current state of the checkbox directly from the DOM
            const sameAsCheckbox = document.querySelector('input[pc="same-as"]') as HTMLInputElement;
            const isSameShippingBilling = sameAsCheckbox?.checked || false;
            
            // Set the current field value in state
            setFormValues((prevFormValues: any) => ({ 
                ...prevFormValues, 
                [pc]: value,
                sameShippingBilling: isSameShippingBilling
            }));
            
            // Process country field changes
            if (pc === 'country' || pc === 's_country') {
                clearStateSelect(selectElement);
                
                // Load regions for the selected country
                await getRegions(value, selectElement);
                
                // Reset state and city values
                if (pc === 'country') {
                    // For billing country change
                    setFormValues((prevFormValues: any) => {
                        const updates = { 
                            ...prevFormValues, 
                            state: '', 
                            city: '',
                            city_id: ''
                        };
                        
                        // If same-as is checked, also update shipping city_id to match
                        if (isSameShippingBilling) {
                            updates.s_city_id = '';
                        }
                        
                        return updates;
                    });
                    
                    // If "same-as" is checked, also update shipping country
                    if (isSameShippingBilling) {
                        const shippingCountrySelect = document.querySelector('select[pc="s-country"]') as HTMLSelectElement;
                        if (shippingCountrySelect && shippingCountrySelect.value !== value) {
                            shippingCountrySelect.value = value;
                            
                            // Clear and load shipping regions
                            clearStateSelect(shippingCountrySelect);
                            await getRegions(value, shippingCountrySelect);
                            
                            // Update shipping form values
                            setFormValues((prevFormValues: any) => ({ 
                                ...prevFormValues, 
                                s_country: value,
                                s_state: '',
                                s_city: '',
                                s_city_id: prevFormValues.city_id // Keep s_city_id in sync with city_id
                            }));
                        }
                    }
                } else if (pc === 's_country') {
                    setFormValues((prevFormValues: any) => ({ 
                        ...prevFormValues, 
                        s_state: '', 
                        s_city: '',
                        s_city_id: isSameShippingBilling ? prevFormValues.city_id : '' // Keep s_city_id in sync if same-as is checked
                    }));
                }
            }
            
            // Process state field changes
            else if (pc === 'state' || pc === 's_state') {
                if (pc === 'state') {
                    // For billing state change
                    setFormValues((prevFormValues: any) => {
                        const updates = {
                            ...prevFormValues,
                            city: '',
                            city_id: ''
                        };
                        
                        // If same-as is checked, also update shipping city values
                        if (isSameShippingBilling) {
                            updates.s_city = '';
                            updates.s_city_id = ''; // Keep city_id values in sync
                        }
                        
                        return updates;
                    });
                    
                    // Clear the city input field
                    const cityInput = getCityInput(selectElement);
                    if (cityInput) {
                        cityInput.value = '';
                    }
                    
                    // If this is a billing state change and "same-as" is checked, update shipping state
                    if (isSameShippingBilling) {
                        const shippingStateSelect = document.querySelector('select[pc="s-state"]') as HTMLSelectElement;
                        if (shippingStateSelect && shippingStateSelect.value !== value) {
                            shippingStateSelect.value = value;
                            const stateEvent = new Event('change', { bubbles: true });
                            shippingStateSelect.dispatchEvent(stateEvent);
                            
                            // Update shipping state (but don't update s_city or s_city_id again - already done above)
                            setFormValues((prevFormValues: any) => ({ 
                                ...prevFormValues, 
                                s_state: value
                            }));
                        }
                        
                        // Clear shipping city input
                        const shippingCityInput = document.querySelector('input[pc="s-city"]') as HTMLInputElement;
                        if (shippingCityInput) {
                            shippingCityInput.value = '';
                        }
                    }
                } 
                else if (pc === 's_state') {
                    // For shipping state change
                    setFormValues((prevFormValues: any) => ({
                        ...prevFormValues,
                        s_city: '',
                        s_city_id: isSameShippingBilling ? prevFormValues.city_id : '' // If same-as is checked, keep s_city_id in sync
                    }));
                    
                    // Clear the shipping city input field
                    const cityInput = getCityInput(selectElement);
                    if (cityInput) {
                        cityInput.value = '';
                    }
                }
            }
        }
    };

    /*=========================================================
    HANDLE AUTOFILL CHANGE
    =========================================================*/
    const handleAutofillChange = _.debounce(async (event: Event) => {
        const pc = (event.target as HTMLInputElement).getAttribute('pc');
        if (pc) {
            const value = (event.target as HTMLInputElement).value;
            setFormValues((prevFormValues: any) => ({
                ...prevFormValues,
                [pc]: value
            }));
        }
    }, 500);

    /*=========================================================
    HANDLE CHECKBOX CHANGE
    =========================================================*/
    const handleSameAsChange = async (event: Event) => {
        const checkbox = event.target as HTMLInputElement;

        setFormValues((prevFormValues: any) => ({ 
            ...prevFormValues, 
            sameShippingBilling: checkbox.checked,
        }));
        
        if (checkbox.checked) {
            const shippingFieldsContainer = document.querySelector('[pc="shipping-information"]');
            if (shippingFieldsContainer) {
                shippingFieldsContainer.classList.add('hidden');
            }

            // Replicate billing fields to shipping fields, including country, state, and city
            const fieldsToReplicate = [
                { billing: 'fname', shipping: 's-fname' },
                { billing: 'lname', shipping: 's-lname' },
                { billing: 'address', shipping: 's-address' },
                { billing: 'address2', shipping: 's-address2' },
                { billing: 'postal', shipping: 's-postal' },
                { billing: 'country', shipping: 's-country' },
                { billing: 'state', shipping: 's-state' },
                { billing: 'city', shipping: 's-city' },
                // No need to add city_id here since it's handled separately below
            ];

            // Replicate input fields
            fieldsToReplicate.forEach(({ billing, shipping }) => {
                const billingElement = document.querySelector(`[pc="${billing}"]`) as HTMLInputElement | HTMLSelectElement;
                const shippingElement = document.querySelector(`[pc="${shipping}"]`) as HTMLInputElement | HTMLSelectElement;

                if (billingElement && shippingElement) {
                    shippingElement.value = billingElement.value;
                    const event = new Event('input', { bubbles: true });
                    shippingElement.dispatchEvent(event);
                }
            });

            // Update formValues
            setFormValues((prevFormValues: any) => {
                const updatedValues = { ...prevFormValues };
                fieldsToReplicate.forEach(({ billing, shipping }) => {
                    const billingKey = billing.replace('-', '_');
                    const shippingKey = shipping.replace('-', '_');
                    updatedValues[shippingKey] = prevFormValues[billingKey];
                });
                
                // Explicitly copy city_id to s_city_id
                if (prevFormValues.city_id) {
                    console.log('Setting s_city_id from city_id:', prevFormValues.city_id); // Debug logging
                    updatedValues.s_city_id = prevFormValues.city_id;
                }
                
                return {
                    ...updatedValues,
                    sameShippingBilling: checkbox.checked,
                };
            });
            

            // Handle asynchronous waits for country and state selection
            const billingCountrySelect = document.querySelector('select[pc="country"]') as HTMLSelectElement;
            const billingStateSelect = document.querySelector('select[pc="state"]') as HTMLSelectElement;
            const shippingCountrySelect = document.querySelector('select[pc="s-country"]') as HTMLSelectElement;
            const shippingStateSelect = document.querySelector('select[pc="s-state"]') as HTMLSelectElement;
            const billingCityInput = document.querySelector('input[pc="city"]') as HTMLInputElement;
            const shippingCityInput = document.querySelector('input[pc="s-city"]') as HTMLInputElement;

            if (billingCountrySelect && shippingCountrySelect) {
                shippingCountrySelect.value = billingCountrySelect.value;
                const countryEvent = new Event('change', { bubbles: true });
                shippingCountrySelect.dispatchEvent(countryEvent);
                await getRegions(billingCountrySelect.value, shippingCountrySelect);

                if (billingStateSelect && shippingStateSelect) {
                    shippingStateSelect.value = billingStateSelect.value;
                    const stateEvent = new Event('change', { bubbles: true });
                    shippingStateSelect.dispatchEvent(stateEvent);
                }

                // Update shipping city_id to match billing city_id
                const shippingCityInput = document.querySelector('input[pc="s-city"]') as HTMLInputElement;
                if (shippingCityInput) {
                    shippingCityInput.value = billingCityInput.value;
                    const cityEvent = new Event('input', { bubbles: true });
                    shippingCityInput.dispatchEvent(cityEvent);
                }
                setFormValues((prevFormValues: any) => ({
                    ...prevFormValues,
                    s_city_id: prevFormValues.city_id
                }));
            }

        } else {
            const shippingFieldsContainer = document.querySelector('[pc="shipping-information"]');
            if (shippingFieldsContainer) {
                shippingFieldsContainer.classList.remove('hidden');
            }
        }
    };


    /*=========================================================
    HANDLE TERMS CHANGE
    =========================================================*/
    const handleTermsChange = async (event: Event) => {
        const checkbox = event.target as HTMLInputElement;
        setFormValues((prevFormValues: any) => ({ 
            ...prevFormValues, 
            checkTerms: checkbox.checked,
        }));
    };




    /*=========================================================
    HELPER FUNCTIONS
    =========================================================*/
    const getStateSelect = (selectElement: HTMLSelectElement) => {
        const pcValue = selectElement.getAttribute('pc');
        if (pcValue === "country") {
            return document.querySelector('[pc="state"]') as HTMLSelectElement;
        } else if (pcValue === "s-country") {
            return document.querySelector('[pc="s-state"]') as HTMLSelectElement;
        }
        return null;
    };

    const getCityInput = (selectElement: HTMLSelectElement) => {
        const pcValue = selectElement.getAttribute('pc');
        if (pcValue === 'country') {
            return document.querySelector('input[pc="city"]') as HTMLInputElement;
        } else if (pcValue === 's-country') {
            return document.querySelector('input[pc="s-city"]') as HTMLInputElement;
        }
        return null;
    };

    const initializeDisabledFields = () => {
        const fieldsToDisable = [
            'select[pc="state"]',
            'input[pc="city"]',
            'select[pc="s-state"]',
            'input[pc="s-city"]'
        ];
        fieldsToDisable.forEach(selector => {
            const element = document.querySelector(selector) as HTMLInputElement | HTMLSelectElement;
            if (element) {
                element.classList.add('disabled');
                element.disabled = true;
            }
        });
    };

    const validateAddressFields = async (data: any = null) => {
        const source = data || formValues;

        // Billing address validation
        const billingStateSelect = document.querySelector('select[pc="state"]') as HTMLSelectElement;
        const billingCityInput = document.querySelector('input[pc="city"]') as HTMLInputElement;

        if (billingStateSelect) {
            if (source.country && source.country !== '') {
                billingStateSelect.disabled = false;
                billingStateSelect.classList.remove('disabled');
            } else {
                billingStateSelect.disabled = true;
                billingStateSelect.classList.add('disabled');
                billingStateSelect.value = '';
                setFormValues((prev: any) => ({ ...prev, state: '' }));
            }
        }

        if (billingCityInput) {
            if (source.state && source.state !== '') {
                billingCityInput.disabled = false;
                billingCityInput.classList.remove('disabled');
            } else {
                billingCityInput.disabled = true;
                billingCityInput.classList.add('disabled');
                billingCityInput.value = '';
                setFormValues((prev: any) => ({ ...prev, city: '' }));
            }
        }

        // Shipping address validation
        const shippingStateSelect = document.querySelector('select[pc="s-state"]') as HTMLSelectElement;
        const shippingCityInput = document.querySelector('input[pc="s-city"]') as HTMLInputElement;

        if (shippingStateSelect) {
            if (source.s_country && source.s_country !== '') {
                shippingStateSelect.disabled = false;
                shippingStateSelect.classList.remove('disabled');
            } else {
                shippingStateSelect.disabled = true;
                shippingStateSelect.classList.add('disabled');
                shippingStateSelect.value = '';
                setFormValues((prev: any) => ({ ...prev, s_state: '' }));
            }
        }

        if (shippingCityInput) {
            if (source.s_state && source.s_state !== '') {
                shippingCityInput.disabled = false;
                shippingCityInput.classList.remove('disabled');
            } else {
                shippingCityInput.disabled = true;
                shippingCityInput.classList.add('disabled');
                shippingCityInput.value = '';
                setFormValues((prev: any) => ({ ...prev, s_city: '' }));
            }
        }
    };

    useEffect(() => {
        if (isInitialized) {
            validateAddressFields();
        }
    }, [formValues.country, formValues.state, formValues.s_country, formValues.s_state]);

    

    return null;
}
